<div role="button" class="menu-item-container d-flex align-items-center" [attr.data-selected]="isSelected()" [routerLink]="'/dashboard/' + userType() + '/' + menuItem().value" routerLinkActive="active">
    <svg-icon [src]="'assets/icons/' + menuItem().icon + '.svg'" class="menu-item-icon d-flex align-items-center justify-content-center"/>
    <span class="nunito">{{menuItem().label | translate}}</span>
</div>
